import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    critical;
    major;
    minor;
    disabled;
    isTime;
    mapArray = ['critical', 'major', 'minor'];
    levelSelected = [false, false, false];
    levelDisabled = [false, false, false];
    valueDisabled = [true, true, true];
    formData = {
        critical: 0,
        major: 0,
        minor: 0,
    };
    range = this.isTime ? '1-600' : '1-999';
    levleChange() {
        let flag = this.levelSelected.lastIndexOf(true);
        if (flag < 0) {
            this.levelDisabled = [false, false, false];
            this.valueDisabled = [true, true, true];
            this.formData = {
                critical: NaN,
                major: NaN,
                minor: NaN,
            };
        }
        for (let i = 0; i < 3; i++) {
            if (i < flag) {
                this.levelSelected[i] = true;
                this.valueDisabled[i] = false;
                this.levelDisabled[i] = true;
            }
            else if (i === flag) {
                this.valueDisabled[i] = false;
                this.levelDisabled[i] = false;
            }
            else {
                this.valueDisabled[i] = true;
                this.levelDisabled[i] = false;
                this.formData[this.mapArray[i]] = NaN;
            }
        }
    }
    created() {
        this.formData = {
            critical: this.critical,
            major: this.major,
            minor: this.minor,
        };
        this.levelSelected[0] = !isNaN(this.critical);
        this.levelSelected[1] = !isNaN(this.major);
        this.levelSelected[2] = !isNaN(this.minor);
        if (this.disabled) {
            this.levelDisabled = [true, true, true];
            this.valueDisabled = [true, true, true];
            this.range = '';
        }
        else {
            this.levleChange();
        }
    }
    changeCritical(val) {
        this.isValidate();
        this.$emit('update:critical', val);
    }
    changeMajor(val) {
        this.isValidate();
        this.$emit('update:major', val);
    }
    changeMinor(val) {
        this.isValidate();
        this.$emit('update:minor', val);
    }
    get rules() {
        let rule = {};
        const flag = this.levelSelected.lastIndexOf(true);
        for (let i = 0; i < 3; i++) {
            if (this.levelSelected[i]) {
                rule[this.mapArray[i]] = [
                    { required: true, message: this.$t('holder') + this.range, trigger: 'blur' },
                    {
                        pattern: this.isTime ? /^([1-9]|[1-9]\d|[1-5]\d\d|600)$/ : /^([1-9]|[1-9]\d|[1-9]\d\d)$/,
                        message: this.$t('holder') + this.range,
                        trigger: 'blur',
                    },
                    {
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (i < flag) {
                                if (Number(value) <= Number(this.formData[this.mapArray[i + 1]])) {
                                    return callback(new Error(this.$t('alart').toString()));
                                }
                                else {
                                    callback();
                                }
                            }
                            else {
                                callback();
                            }
                        },
                    },
                ];
            }
            else {
                rule[this.mapArray[i]] = [{ required: false }];
            }
        }
        return rule;
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
};
__decorate([
    Prop()
], default_1.prototype, "critical", void 0);
__decorate([
    Prop()
], default_1.prototype, "major", void 0);
__decorate([
    Prop()
], default_1.prototype, "minor", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "isTime", void 0);
__decorate([
    Watch('levelSelected')
], default_1.prototype, "levleChange", null);
default_1 = __decorate([
    Component({
        name: 'OptionThreshold',
        components: {},
        i18n: {
            messages: {
                zh: {
                    level: '告警等级',
                    threshold: '阈值',
                    visitor: '（人数）',
                    time: '（滞留时长）',
                    critical: '重度',
                    major: '中度',
                    minor: '轻度',
                    seconds: '秒',
                    holder: '请输入 ',
                    alart: '高等级阈值必须大于低等级阈值',
                },
                'en-us': {
                    level: 'Level',
                    threshold: 'Threshold',
                    visitor: '(visitors)',
                    time: '(retention time)',
                    critical: 'Critical',
                    major: 'Major',
                    minor: 'Minor',
                    seconds: 'Seconds',
                    holder: 'Please enter ',
                    alart: 'High level must be greater than low level threshold',
                },
            },
        },
    })
], default_1);
export default default_1;
